import React, { useEffect, useMemo, useRef } from 'react'
import { useMeeting, useParticipant } from "@videosdk.live/react-sdk";
import ReactPlayer from 'react-player';

const PresenterView = ({ presenterId }) => {
    const { screenShareAudioStream,micStream, isLocal, screenShareStream, screenShareOn } = useParticipant(presenterId);

    //Creating a media stream from the screen share stream
    const mediaStream = useMemo(() => {
        if (screenShareOn && screenShareStream) {
            const mediaStream = new MediaStream();
            mediaStream.addTrack(screenShareStream.track);
            return mediaStream;
        }
    }, [screenShareStream, screenShareOn]);

    const audioPlayer = useRef();
    // console.log('screenShareAudioStream',screenShareAudioStream,'screenShareStream',screenShareStream)
//     useEffect(() => {
//         if (
//             // !isLocal &&
//             audioPlayer.current &&
//             // screenShareOn &&
//             micStream
//         ) {
//             const mediaStream = new MediaStream();
//             mediaStream.addTrack(micStream.track);
// // console.log('here')
//             audioPlayer.current.srcObject = mediaStream;
//             audioPlayer.current.play().catch((err) => {
//                 if (
//                     err.message ===
//                     "play() failed because the user didn't interact with the document first. https://goo.gl/xX8pDD"
//                 ) {
//                     console.error("audio" + err.message);
//                 }
//             });
//         } else {
//             audioPlayer.current.srcObject = null;
//         }
//     }, [micStream, screenShareOn, isLocal]);
    return (
        <>
      // playing the media stream in the ReactPlayer
            <ReactPlayer
                //
                playsinline // extremely crucial prop
                playIcon={<></>}
                //
                pip={false}
                light={false}
                controls={false}
                // muted={true}
                playing={true}
                //
                url={mediaStream} // passing mediastream here
                //
                // height={"100%"}
                width={"100%"}
                onError={(err) => {
                    console.log(err, "presenter video error");
                }}
            />
            {/* <audio autoPlay playsInline controls={false} ref={audioPlayer} /> */}
        </>
    )
}

export default PresenterView